export const initialValues = {
    welcome_message: '',
    image: null,
};
